import {Component, OnInit} from '@angular/core';
import {TimeTrackingService} from '../../shared/time-tracking.service';
import {Address} from '../../interfaces/trip';

/** The person's own home address (#874), copied into a trip when they pick "Home". */
@Component({
  selector: 'bst-home-address',
  templateUrl: './home-address.component.html',
  styles: [`
    .hint { color: var(--text-hint-color); font-size: 0.85rem; }
    .home-address { display: flex; flex-wrap: wrap; gap: 0.5rem; }
  `],
  standalone: false
})
export class HomeAddressComponent implements OnInit {
  address: Partial<Address> = {street: '', number: '', postcode: '', town: ''};
  busy = false;

  constructor(private time: TimeTrackingService) {}

  async ngOnInit() {
    this.address = await this.time.getHomeAddress().catch(() => this.address);
  }

  async save() {
    this.busy = true;
    this.address = await this.time.saveHomeAddress(this.address).catch(() => this.address);
    this.busy = false;
  }
}
